import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'
import { getIsEditing, getIsSimulating } from 'selectors/navigator'
import { classNames } from 'utils/utils'
import { FUNCTION_DESCRIPTION_MAX_LENGTH } from 'utils/constants'

import { Header } from 'components/patterns'

import { HeaderStyled } from 'components/feature/NavigatorPanes/editors/Editors.style'
import PowerNetLevelSimulator from 'components/feature/Simulation/PowerNetLevelSimulator'
import FunctionEditor from './FunctionEditor'
import FunctionNavList from './FunctionNavList'

import withStyle, { OverRunDescription } from './FunctionPane.style.js'
import { ViewNotesButton } from '../FeatureNotes/FeatureNotes'

const FunctionPane = ({ className, ...navigatorProps }) => {
  const isEditing = useSelector(getIsEditing)
  const isSimulating = useSelector(getIsSimulating)
  const { description, selectedId, type } = navigatorProps
  const savableDescription = description.substring(
    0,
    FUNCTION_DESCRIPTION_MAX_LENGTH - 1
  )
  const descriptionOverRun = description.substring(
    FUNCTION_DESCRIPTION_MAX_LENGTH
  )

  return (
    <div className={classNames(className, 'function-pane')}>
      {isEditing ? (
        <FunctionEditor {...navigatorProps}>
          <ViewNotesButton
            id={selectedId}
            fromType={type}
            description={savableDescription}
          />
          <HeaderStyled>
            <Header type="h3">
              {savableDescription}
              {descriptionOverRun && (
                <OverRunDescription>{descriptionOverRun}</OverRunDescription>
              )}
            </Header>
          </HeaderStyled>
        </FunctionEditor>
      ) : (
        <FunctionNavList {...navigatorProps}>
          <ViewNotesButton
            id={selectedId}
            fromType={type}
            description={savableDescription}
          />
          <HeaderStyled>
            <Header type="h3">
              {savableDescription}
              {descriptionOverRun && (
                <OverRunDescription>{descriptionOverRun}</OverRunDescription>
              )}
            </Header>
          </HeaderStyled>
          {isSimulating && <PowerNetLevelSimulator />}
        </FunctionNavList>
      )}
    </div>
  )
}

FunctionPane.defaultProps = {}

FunctionPane.propTypes = {
  /** Make sure to comment */
  /** Classname */
  className: PropTypes.string,
}

export default withStyle(FunctionPane)
